export const FETCH_INGREDIENT = {
  START: 'START_FETCH_INGREDIENT',
  COMPLETE: 'COMPLETE_FETCH_INGREDIENT',
  FAIL: 'FAIL_FETCH_INGREDIENT',
  CLEANUP: 'CLEANUP_FETCH_INGREDIENT',
}

export const UPDATE_INGREDIENT_SIMPLE_DETAILS = {
  START: 'START_UPDATE_INGREDIENT_SIMPLE_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_INGREDIENT_SIMPLE_DETAILS',
  FAIL: 'FAIL_UPDATE_INGREDIENT_SIMPLE_DETAILS',
}

export const UPDATE_INGREDIENT_IMAGE_DETAILS = {
  START: 'START_UPDATE_INGREDIENT_IMAGE_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_INGREDIENT_IMAGE_DETAILS',
  FAIL: 'FAIL_UPDATE_INGREDIENT_IMAGE_DETAILS',
}

export const UPDATE_INGREDIENT_NOTES = {
  START: 'START_UPDATE_INGREDIENT_NOTES',
  COMPLETE: 'COMPLETE_UPDATE_INGREDIENT_NOTES',
  FAIL: 'FAIL_UPDATE_INGREDIENT_NOTES',
}

export const UPDATE_INGREDIENT_EXTRA_DETAILS = {
  START: 'START_UPDATE_INGREDIENT_EXTRA_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_INGREDIENT_EXTRA_DETAILS',
  FAIL: 'FAIL_UPDATE_INGREDIENT_EXTRA_DETAILS',
}

export const UPDATE_INGREDIENT_COMPONENT_DETAILS = {
  START: 'START_UPDATE_INGREDIENT_COMPONENT_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_INGREDIENT_COMPONENT_DETAILS',
  FAIL: 'FAIL_UPDATE_INGREDIENT_COMPONENT_DETAILS',
}

export const UPDATE_INGREDIENT_OVERRIDES_INGREDIENTS_DETAILS = {
  START: 'START_UPDATE_INGREDIENT_OVERRIDES_INGREDIENTS_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_INGREDIENT_OVERRIDES_INGREDIENTS_DETAILS',
  FAIL: 'FAIL_UPDATE_INGREDIENT_OVERRIDES_INGREDIENTS_DETAILS',
}

export const UPDATE_INGREDIENT_ALTERNATIVE_INGREDIENTS_DETAILS = {
  START: 'START_UPDATE_INGREDIENT_ALTERNATIVE_INGREDIENTS_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_INGREDIENT_ALTERNATIVE_INGREDIENTS_DETAILS',
  FAIL: 'FAIL_UPDATE_INGREDIENT_ALTERNATIVE_INGREDIENTS_DETAILS',
}

export const SET_INGREDIENT_PAGE_TO_DIRTY = 'SET_INGREDIENT_PAGE_TO_DIRTY'
